import React, { Component } from 'react';
import RadioGroup from '../../../common/radioGroup'

class InputRow extends Component {
    constructor(props) {
        super(props);
        this.labelStyle = {color: "slate", fontSize: "14px"};
        this.requiredStyle = {color: "red", fontSize: "14px"};
    }    


radioRow = (name, title, value, options, note) => {
  const labStyle = this.props.required ? this.requiredStyle : this.labelStyle;
  return (<>
    <div className="row">
      <div className="col-12">
        <label style={labStyle} htmlFor={name}>{title}</label> {note}
        <br/>
          <RadioGroup
            name={name}
            onChange={this.props.onChange}
            options={options}
            value={value}
            disabled={this.props.disabled}            
          />
      </div>
    </div> 
    <br />
  </>)
  }

textRow = (name, title, value, placeholder, note) => {
  const labStyle = this.props.required ? this.requiredStyle : this.labelStyle;

return (<>
    <div className="row">
    <div className="col-12">
        <label style={labStyle} htmlFor={name}>{title}</label> {note}
        <br/>
        <input
              type='text'
              id={name}
              name={name}
              defaultValue={value}
              onChange={this.props.onChange}
              className="form-control"
              placeholder={placeholder} 
              disabled={this.props.disabled}
        />
    </div>
    </div> 
    <br />
</>)
}
  
render() {
    const {type, name, title, value, placeholder, note, options} = this.props;
    switch(type) {
        case 'radio': return this.radioRow(name, title, value, options, note); 
        case 'text': return this.textRow(name, title, value, placeholder, note);
        default: return null;
    }
  }
}

export default InputRow;

